import { ConnectionPositionPair } from "@angular/cdk/overlay";

export const toolTipPosstions: ConnectionPositionPair[] = [
    // Posição Preferencial: Acima e centralizado
    {
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'bottom',
      offsetY: -10, // Um pequeno espaço de 10px
    },
    // Fallback 1: Abaixo e centralizado
    {
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
      offsetY: 10,
    },
    // Fallback 2: À direita do ícone
    {
      originX: 'end',
      originY: 'center',
      overlayX: 'start',
      overlayY: 'center',
      offsetX: 10,
    },
    // Fallback 3: À esquerda do ícone
    {
      originX: 'start',
      originY: 'center',
      overlayX: 'end',
      overlayY: 'center',
      offsetX: -10,
    },
  ];